import React from 'react';
import Loading from 'components/Loading';
import Toast from 'components/Toast';
import APP from 'stores/APP';
import { compressImage, getInputAcceptProp } from './helper';
import { IAcceptItem } from './types';

export interface IFileInputProps {
    allow: {
        allowText: string;
        accepts: IAcceptItem[];
        descriptionText: string;
    };
    onChange: (file: File) => void;
    uploading?: boolean;
    downloading?: boolean;
    progress?: number;
    error?: Error | null;
    isMobile?: boolean;
}

const FileInput: React.FC<IFileInputProps> = ({
    allow,
    onChange,
    uploading,
    progress,
    error,
    isMobile,
    downloading
}) => {
    const onClick = (ev: React.MouseEvent) => {
        ev.preventDefault();

        const input = document.createElement('input');

        input.type = 'file';

        // can i use上显示安卓浏览器不支持accept属性
        // 实际测试情况表明, 不同品牌的安卓手机对于accept的处理形式各不相同
        if (!APP.isAndroid) {
            input.accept = getInputAcceptProp(allow.accepts, isMobile);
        }

        input.onchange = fileEvent => {
            const { files } = fileEvent.target as HTMLInputElement;

            if (files?.length) {
                const file = files[0];

                for (const item of allow.accepts) {
                    // 检查文件大小是否超出限制maxSize
                    if (item.maxSize && file.size > item.maxSize) {
                        Toast.show(item.maxSizeText);

                        return;
                    }

                    const acceptReg = new RegExp(item.accept, 'i');

                    // 如果文件类型能够匹配accept且后缀可以匹配到允许的ext,就对图片做出改变
                    if (acceptReg.test(file.type) || item.ext.some(ext => file.name.endsWith(ext))) {
                        compressImage(file)
                            .then(res => {
                                onChange(res as File);
                            })
                            .catch(e => {
                                Toast.show(e.message);
                            })
                            .finally(() => {
                                document.body.removeChild(input);
                            });

                        return;
                    }
                }

                Toast.show(allow.allowText);
            }

            document.body.removeChild(input);
        };

        // ios上，input必须插入到页面dom树中，才能触发onchange事件
        // display = none并不是最好的方式，mdn上实例给出的方案是将opacity设置为0
        // 因为display:none和visibility:hidden在辅助技术中并不是交互式的
        input.style.opacity = '0';
        input.style.width = '0';
        input.style.height = '0';
        input.style.position = 'absolute';
        document.body.appendChild(input);

        input.click();
    };

    return (
        <div className="file-select-trigger" onClick={onClick}>
            <div className="upload-icon" />
            <div className="file-select-placeholder">
                {error ? (
                    error.message
                ) : uploading ? (
                    `${__('上传中')}(${progress}%)`
                ) : downloading ? (
                    <Loading className="text-normal" tip={__('下载中...')} />
                ) : (
                    <div className="file-select-desc">
                        <div>{__('点击上传')}</div>
                        {!!allow.descriptionText && <p dangerouslySetInnerHTML={{ __html: allow.descriptionText }}></p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FileInput;
